import SharedFile from '@juvare/common-web-ui/icons/SharedFile';
import SharedFolder from '@juvare/common-web-ui/icons/SharedFolder';
import SharedImage from '@juvare/common-web-ui/icons/SharedImage';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import FolderIcon from '@mui/icons-material/Folder';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
export const fileTypeToIconMap = {
    image: {
        icon: ImageIcon,
        color: themeColors.accent.green.base,
    },
    sharedImage: {
        icon: SharedImage,
        color: themeColors.accent.green.base,
    },
    file: {
        icon: InsertDriveFileIcon,
        color: themeColors.accent.blue.base,
    },
    sharedFile: {
        icon: SharedFile,
        color: themeColors.accent.blue.base,
    },
    folder: {
        icon: FolderIcon,
        color: themeColors.accent.orange.base,
    },
    sharedFolder: {
        icon: SharedFolder,
        color: themeColors.accent.orange.base,
    },
};
